import { ReactNode } from "react";

type Props = {
  title: string;
  titleContent?: ReactNode;
  content: string | number;
};
export default function DashboardSummaryCard({
  title,
  titleContent,
  content,
}: Props) {
  const isNumber = typeof content === "number";
  return (
    <div className="flex-1 self-stretch p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-gray-D inline-flex flex-col justify-between items-start">
      <div className="self-stretch h-4 flex justify-between items-center">
        <div className="min-w-16 justify-center text-gray-B text-sm font-semibold">
          {title}
        </div>
        {titleContent}
      </div>
      <div className="self-stretch inline-flex justify-end items-center text-4xl font-semibold">
        {isNumber ? content.toLocaleString() : content}
      </div>
    </div>
  );
}
